import '../style.less';
import {useSelector} from 'react-redux';
import {getTitleDataGrid} from 'src/domain/app/redux/data-grid/data-grid-selectors';
import IntlMessages from 'src/domain/utility/IntlMessages';
import MainUtils from 'src/shared/utils/main';

const HeaderDataGrid: React.FC = () => {
  const title = useSelector(getTitleDataGrid);
  return (
    <h3 className='title-header'>
      {!MainUtils.isEmptyValue(title) ? <IntlMessages id={title} /> : ''}
    </h3>
  );
};

export default HeaderDataGrid;
